import uuid from "uuid";

import {
    TOASTR_ADD,
    TOASTR_REMOVE,
    TOASTR_RESET
} from '../constants/ActionTypes';

const initialState = {
    messages: []
};

export default function Toastr(state = initialState, action) {
    switch (action.type) {
        case TOASTR_ADD:
            let updatedMessages = [...state.messages];
            if(Array.isArray(action.payload)) {
                updatedMessages = updatedMessages.concat(action.payload);
            } else {
                updatedMessages.push({...action.payload, index: uuid.v1()});
            }
            return {
                ...state,
                messages: updatedMessages
            };
        case TOASTR_REMOVE:
            return {
                ...state,
                messages: [...state.messages].filter(msg => msg.index !== action.index)
            }
        case TOASTR_RESET:
            return initialState;
        default:
            return state;
    }
}